import { TypedMessages } from '@nxsys/hooks/useTypedIntl';
import { Icons } from '@nxsys/types/icons';
import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import moment from 'moment';

export const getColumns = ({
  messages,
}: {
  messages: TypedMessages;
}): ColumnsType<any> => {
  return [
    {
      key: 'action',
      title: messages['common.action'],
      fixed: 'left',
      align: 'left',
      render: (record) => (
        <ul>
          <li onClick={() => window.open(record?.linkFile, '_blank')}>
            <Tooltip title="Download">
              <span><Icons.IconDownload /></span>
            </Tooltip>
          </li>
        </ul>
      ),
      width: 100,
    },
    {
      key: 'fileName',
      title: messages['export.company.fileName'],
      dataIndex: 'fileName',
      width: 400,
    },
    {
      key: 'companies',
      title: messages['export.company.companiesName'],
      dataIndex: 'companies',
      render: (record) =>
        record?.map((item: any) => item?.companyName)?.join(', '),
    },
    {
      key: 'exportOn',
      title: messages['export.company.exportOn'],
      dataIndex: 'exportOn',
      render: (record) =>
        record ? moment(record).format('DD/MM/YYYY HH:mm') : '',
    },
    {
      key: 'exportBy',
      title: messages['export.company.exportBy'],
      dataIndex: 'exportBy',
      render: (record) => `${record?.forename ?? ''} ${record?.surname ?? ''}`,
    },
  ];
};
